import { render, staticRenderFns } from "./top-theme.vue?vue&type=template&id=71fdf79a&scoped=true&"
import script from "./top-theme.vue?vue&type=script&lang=js&"
export * from "./top-theme.vue?vue&type=script&lang=js&"
import style0 from "./top-theme.vue?vue&type=style&index=0&id=71fdf79a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fdf79a",
  null
  
)

export default component.exports